import { UnauthorizedError } from '@omecare/utils';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import http from '@/utils/http.service';

const doctolibImportDataItemSchema = z.object({
  date: z.string(),
  invoiceIdentifier: z.string(),
  totalAmountDue: z.coerce.number(),
  totalAmountPaid: z.coerce.number(),
});

const doctolibImportResponseSchema = z.object({
  id: z.string().uuid(),
  periodFrom: z.string(),
  periodTo: z.string(),
  workScheduleDoctolibData: z.array(doctolibImportDataItemSchema).nullable(),
});

export type DoctolibImportResponse = z.infer<
  typeof doctolibImportResponseSchema
>;

const getDoctolibImport = (id: string) => async () => {
  const data = await http.accountings.getDoctolibImport(id);
  return doctolibImportResponseSchema.parse(data);
};

export const useGetDoctolibImportQuery = (
  id: string | null,
): UseQueryResult<DoctolibImportResponse, UnauthorizedError> => {
  return useQuery({
    queryFn: getDoctolibImport(id!),
    queryKey: ['doctolib-import', id],
    enabled: !!id,
    retry: false,
  });
};
